import date from "../../core/utils/date";
import { StrapiModel } from "./StrapiModel";

export class CMSPopupDialog extends StrapiModel {
    slug: string;
    image: string;
    href: string;

    weight: number;

    width: number;
    height: number;
    marginTop: number;
    coolDownInHours: number;

    constructor(obj?: Partial<CMSPopupDialog>) {
        super();
        Object.assign(this, obj);
    }
}